import { render, staticRenderFns } from "./TableauComponent.vue?vue&type=template&id=dd8c4a3e&scoped=true&"
import script from "./TableauComponent.vue?vue&type=script&lang=js&"
export * from "./TableauComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8c4a3e",
  null
  
)

export default component.exports